import { createBaseCrudMachine } from '~/machines/base-crud';
import { CMETraining } from '~/types';
import { API_CALLS } from './api';
import { emptyForm } from './constants';
import { CMESort, CMETrainingFormValues } from './types';

export const cmeTrainingMachine = createBaseCrudMachine<
  CMETraining,
  CMETrainingFormValues,
  CMESort
>({
  initialForm: emptyForm,
  sort: {
    sortBy: 'id',
    activity_date: -1,
    course_title: -1,
    credit_type: -1,
    credits_earned: -1,
    id: 1,
    page: 1,
    pageSize: 100,
  },
  apiCalls: API_CALLS,
});
